import { BoundNumberField, BoundNumberFieldProps } from "@homebound/beam";
import { Observer } from "mobx-react";
import { ObjectState } from "src/utils/formState";
import { AiFieldProposalFormValue } from "./utils/aiFieldProposalForm";
import { parseAiNumber, pendingProposedValue, resolveAiProposalStatus } from "./utils/bindAiProposal";

export type BoundAiNumberFieldProps = Omit<BoundNumberFieldProps, "proposedValue"> & {
  aiProposal?: ObjectState<AiFieldProposalFormValue>;
};

export function BoundAiNumberField(props: BoundAiNumberFieldProps) {
  const { field, aiProposal, onChange, ...others } = props;
  // Observer wrapper needed for `aiProposal.status` / `fieldValue` so the pending proposal stays in sync.
  return (
    <Observer>
      {() => (
        <BoundNumberField
          field={field}
          proposedValue={pendingProposedValue(aiProposal, parseAiNumber)}
          onChange={(value) => {
            field.set(value);
            resolveAiProposalStatus(aiProposal, parseAiNumber, value);
            onChange?.(value);
          }}
          {...others}
        />
      )}
    </Observer>
  );
}
